<template>
  <div class="left_list_wrap" :class="{yincang_active: chunjing}">
    <ul class="left-right_list_ul">
      <li class="left-right_list_li">
        <div class="tit">
          {{dayType}}警情未处理数量单位排名
        </div>
        <div class="tubiao">
          <div class="tubiao_main left_top_wrap echarts_bg_color">
            <ul class="tubiao_tj dp_fs_color">
              <li class="" v-for="(item, index) in left_nav_arr" :key='index' :class="{active: topNavIndex == index}" @click='left_nav_click(index)'>
                {{item}}
              </li>
            </ul>
            <div class="tubiao_box1" id="left_top" v-show="!no_data_status_top"></div>
            <div class="ani_wrap" v-show="ani_status_top">
              <img :src="tableLoad" />
            </div>
            <div class="no_data_pic_wrap" :class="{hide_svg: !ani_status_top}" v-show="no_data_status_top">
              <img :src="noData_pic" alt="">
            </div>
          </div>
        </div>
      </li>
      <li class="left-right_list_li">
        <div class="tit">
          {{dayType}}警情数量统计
        </div>
        <div class="tubiao">
          <div class="tubiao_main left_mid_wrap echarts_bg_color">
            <div class="tubiao_box2" id="left_mid" v-show="!no_data_status_mid"></div>
            <div class="ani_wrap" v-show="ani_status_mid">
              <img :src="tableLoad" /></div>
            <div class="no_data_pic_wrap" :class="{hide_svg: !ani_status_mid}" v-show="no_data_status_mid">
              <img :src="noData_pic" alt="">
            </div>
          </div>
        </div>
      </li>
      <li class="left-right_list_li">
        <div class="tit">
          近30天警情历史趋势
        </div>
        <div class="tubiao">
          <div class="tubiao_main left_bot_wrap echarts_bg_color" @click="botClick">
            <div class="tubiao_box2" id="left_bottom"></div>
            <div class="ani_wrap" v-show="ani_status_bot">
              <img :src="tableLoad" /></div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
    import tableLoad from '@/assets/img/animation.gif';
    import {themeArr} from '@/assets/js/theme.js'
    import no_data_pic from '@/assets/img/no_data_pic.png'
    export default {
        name: "",
        data: () => ({
            tableLoad,
            dateIndex: 0,
            topNavIndex: 0,
            dayType: '今日',
            topOption: '',
            botOption: '',
            left_top_echart: '',
            left_mid_echart: '',
            left_bot_chart: '',
            ani_status_top: true,
            ani_status_mid: true,
            ani_status_bot: true,

            no_data_status_top: false,
            no_data_status_mid: false,
            // no_data_status_bot: false,

            noData_pic: no_data_pic,
            left_nav_arr: ["火警", "报警", "预警", "隐患", "故障"],
            left_bot_arr: [],
            hashValue: '',
            loginData: '',
            echarts_color: themeArr[0].color,
            beginTime: '',
            endTime: '',
            timeArr: [],
        }),
        props:['chunjing', 'headSetaData', 'themeStatus'],
        watch: {
            "themeStatus": function (res) {
                console.log(res);
                switch (res) {
                    case 0:
                        this.echarts_color = themeArr[1].color;
                        break;
                    case 1:
                        this.echarts_color = themeArr[0].color;
                        break;
                }
                //修改文字颜色
                //上图
                this.topOption.tooltip.textStyle.color = this.echarts_color;
                this.topOption.xAxis[0].axisLabel.textStyle.color = this.echarts_color;
                this.topOption.yAxis[0].axisLabel.textStyle.color = this.echarts_color;
                //下图
                for(let i = 0;i< this.botOption.series.length; i++){
                    this.botOption.series[i].label.normal.textStyle.color = this.echarts_color;
                }

                this.left_top_echart.setOption(this.topOption);
                this.left_mid_echart.setOption(this.topOption);
                this.left_bot_chart.setOption(this.botOption);
            },
            'headSetaData': function(res){
                console.log(res);
                console.log('头部日期选择');
                this.dateIndex = res;
                // this.left_bot_chart.dispose();
                switch (res) {
                    case 0: //日
                        this.dayType = '今日';
                        break;
                    case 1: //周
                        this.dayType = '本周';
                        break;
                    case 2: //月
                        this.dayType = '本月';
                        break;
                }
                
                // 左上左中保持联动
                this.getTopData();
                this.getMidData();
            }
        },
        components: {},
        created() {
            this.hashValue = window.localStorage.getItem('hashValue');
            this.loginData = JSON.parse(window.localStorage.getItem('loginData'));   
            this.getTime();         
        },
        mounted() {
            this.getTopData();
            this.getMidData()
            this.getBotData();
        },
        computed: {},
        methods: {
            getTime(){
                let date = new Date();
                let year = date.getFullYear();
                let month = date.getMonth()+1;
                let day = date.getDate();
                let nowDate = year + "-" + (month < 10 ? "0" + month : month) + "-" + (day < 10 ? "0" + day : day);
                let lastDate = new Date(date - 1000 * 60 * 60 * 24 * 30);//最后30天可以更改，意义：是获取多少天前的时间
                let lastY = lastDate.getFullYear();
                let lastM = lastDate.getMonth()+1;
                let lastD = lastDate.getDate();
                let LDate = lastY + "-" + (lastM < 10 ? "0" + lastM : lastM) + "-" +(lastD < 10 ? "0" + lastD : lastD);//得到30天前的时间

                this.beginTime = LDate;
                this.endTime = nowDate;

                for(let i = 30; i >= 0; i--){
                    let date = new Date();
                    let _date = new Date(date - 1000 * 60 * 60 * 24 * i);//最后30天可以更改，意义：是获取多少天前的时间
                    let y = _date.getFullYear();
                    let m = _date.getMonth()+1;
                    let d = _date.getDate();
                    let day = y + "-" + (m < 10 ? "0" + m : m) + "-" +(d < 10 ? "0" + d : d);//得到30天前的时间
                    this.timeArr.push(day);
                }
            },
            //获取数据结束
            left_bot_style(res){
                let colorStyle59 = {
                    normal: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: "#ee0707" // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: "#ef2320" // 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        }
                    }
                };
                let colorStyle60 = {
                    normal: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: "#f0720c" // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: "#f6600e" // 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        }
                    }
                };
                let colorStyle80 = {
                    normal: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: "#ead810" // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: "#bea30d" // 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        }
                    }
                };
                let colorStyle100 = {
                    normal: {
                        color: {
                            type: "linear",
                            x: 0,
                            y: 0,
                            x2: 0,
                            y2: 1,
                            colorStops: [
                                {
                                    offset: 0,
                                    color: "#1bdb48" // 0% 处的颜色
                                },
                                {
                                    offset: 1,
                                    color: "#6ff294" // 100% 处的颜色
                                }
                            ],
                            globalCoord: false // 缺省为 false
                        }
                    }
                };

                if(res < 60){
                    return colorStyle59;
                }else if(res < 80 && res >= 60){
                    return colorStyle60;
                }else if(res < 100 && res >= 80){
                    return colorStyle80;
                }else if(res == 100){
                    return colorStyle100;
                }
            },
            leftBotInit(data) {
                let seriesArr = [];
                Object.keys(data).forEach((item)=>{
                    let obj = {};
                    if(item == 'flamingFire'){ //火警
                        obj = {
                            type: "line",
                            name: "火警",
                            data: data[item].map((item)=>{
                                return item.count;
                            }),
                            showSymbol:false,
                            itemStyle: {
                                normal: {
                                    color: '#CC0000',
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: '#CC0000'
                                    }
                                }
                            }, 
                            symbolSize: 5, 
                            // areaStyle: {},
                        };
                        seriesArr[0] = obj;
                    }
                    if(item == 'fire'){ //报警
                        obj = {
                            type: "line",
                            name: "报警",
                            data: data[item].map((item)=>{
                                return item.count;
                            }),
                            showSymbol:false,
                            itemStyle: {
                                normal: {
                                    color: '#ff0000',
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: '#ff0000'
                                    }
                                }
                            }, 
                            symbolSize: 5, 
                            // areaStyle: {},
                        };
                        seriesArr[1] = obj;
                    }
                    if(item == 'warn'){ //预警
                        obj = {
                            type: "line",
                            name: "预警",
                            data: data[item].map((item)=>{
                                return item.count;
                            }),
                            showSymbol:false,
                            itemStyle: {
                                normal: {
                                    color: '#FF6600',
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: '#FF6600'
                                    }
                                }
                            }, 
                            symbolSize: 5, 
                            // areaStyle: {},
                        };
                        seriesArr[2] = obj;
                    }
                    if(item == 'hiddenHazard'){ //隐患
                        obj = {
                            type: "line",
                            name: "隐患",
                            data: data[item].map((item)=>{
                                return item.count;
                            }),
                            showSymbol:false,
                            itemStyle: {
                                normal: {
                                    color: '#FFFF99',
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: '#FFFF99'
                                    }
                                }
                            }, 
                            symbolSize: 5, 
                            // areaStyle: {},
                        };
                        seriesArr[3] = obj;
                    }
                    if(item == 'fault'){ // 故障
                        obj = {
                            type: "line",
                            name: "故障",
                            data: data[item].map((item)=>{
                                return item.count;
                            }),
                            showSymbol:false,
                            itemStyle: {
                                normal: {
                                    color: '#FFCC00',
                                    lineStyle: {
                                        width: 3,
                                        type: "solid",
                                        color: '#FFCC00'
                                    }
                                }
                            }, 
                            symbolSize: 5, 
                            // areaStyle: {},
                        };
                        seriesArr[4] = obj;
                    }
                });

                let that = this;
                let option = {
                    color: "#fff",
                    tooltip: {
                        trigger: "axis",
                        axisPointer: {
                            type: "cross"
                        },
                        backgroundColor:"rgba(50, 50, 50, .7)",
                        borderColor:"rgba(50, 50, 50, 1)",
                        textStyle:{
                          color:"#FFFFFF"
                        },
                        confine: true,
                    },
                    legend: {
                        data: ['火警', '报警', '预警', '隐患', '故障'],
                        top: '2%',
                        textStyle: {
                            color: this.echarts_color
                        },
                        icon: 'roundRect',
                    },
                    grid: {
                        left: "5%",
                        right: "4%",
                        bottom: "3%",
                        top: "20%",
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: "category",
                            boundaryGap: false,
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: "#7DB4DB",
                              }
                            },
                            data: this.timeArr,
                            axisLabel: {
                                textStyle: {
                                    color: this.echarts_color,
                                    fontSize: 14,
                                }
                            }
                        }
                    ],
                    yAxis: [
                        {
                            minInterval:1,
                            type: "value",
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: "transparent",
                              }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: this.echarts_color,
                                    fontSize:14,
                                    fontFamily: "Microsoft YaHei",
                                    fontWeight: 400,
                                }
                            },
                            splitLine: {
                                lineStyle: {
                                    color: "#122856",
                                }
                            }
                        }
                    ],
                    series: seriesArr
                };
                this.botOption = option;
                this.left_bot_chart = this.$echarts.init(document.getElementById("left_bottom"));
                this.left_bot_chart.setOption(option);
                // this.left_bot_chart.off('click');
                // this.left_bot_chart.on('click',function (params) {
                //     console.log(params);
                    
                //     
                // });
                this.$emit('left_bot', this.left_bot_chart);
            },
            botClick(){
                let obj = {
                    status: true,
                    type: 'leftBot',
                    navIndex: '',
                }
                this.$store.commit('showLayer', obj);
            },
            left_nav_click(index){
                this.topNavIndex = index;
                this.$store.commit('leftTopNavIndex', index);
                this.getTopData();
            },
            getTopData(){
                if(this.left_top_echart){
                    this.left_top_echart.clear();
                }
                this.ani_status_top = true;
                this.no_data_status_top = false;

                let dateType = '';
                switch (this.dateIndex) {
                    case 0:
                        dateType  = 'thisDay';
                        break;
                    case 1:
                        dateType  = 'thisWeek';
                        break;
                    case 2:
                        dateType  = 'thisMonth';
                        break;
                }
                let states = '';
                let type = '';
                switch (this.topNavIndex) {
                    case 0:
                        states = '0,1';
                        type = 'flamingFire';
                        break;
                    case 1:
                        states = '0,1';
                        type = 'fire';
                        break;
                    case 2:
                        states = '0';
                        type = 'warn';
                        break;
                    case 3:
                        states = '0';
                        type = 'hiddenHazard'; //隐患
                        break;
                    case 4:
                        states = '0';
                        type = 'fault'; //故障
                        break;
                }

                let dataObj = {
                    type: 'get',
                    url: '/mcbw/dep_stats/event/state_count',
                    obj: {
                        "dateType": dateType,
                        "type": type,
                        "sortType": "DESC",
                        "pageSize": 100,
                        "currentPage": 1,
                        states: states,
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    console.log('左上数据');
                    console.log(res);
                    this.ani_status_top = false;
                    if(res.data.success && res.data.data.length){
                        this.$nextTick(()=>{
                            this.topMidInit(res.data.data.slice(0, 5), 'top');
                        });
                    }else{
                        this.no_data_status_top = true;
                        return false;
                    }
                });
            },
            getMidData(){
                if(this.left_mid_echart){
                    this.left_mid_echart.clear();
                }
                this.ani_status_mid = true;
                this.no_data_status_mid = false;

                let dateType = '';
                switch (this.dateIndex) {
                    case 0:
                        dateType  = 'thisDay';
                        break;
                    case 1:
                        dateType  = 'thisWeek';
                        break;
                    case 2:
                        dateType  = 'thisMonth';
                        break;
                }
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/dep_stats/event/count',
                    obj: {
                        "dateType": dateType,
                        "sortType": "DESC",
                    }
                }

                this.$Axios(dataObj).then((res)=>{
                    console.log('左中数据');
                    console.log(res);
                    this.ani_status_mid = false;
                    if(res.data.success){
                        let dataArr = [];
                        for(let i = 0; i < Object.keys(res.data.data).length; i++){
                            if(i == 0){
                                dataArr.push({
                                    name: '火警',
                                    value: res.data.data['flamingFire']
                                });
                            }
                            if(i == 1){
                                dataArr.push({
                                    name: '报警',
                                    value: res.data.data['fire']
                                });
                            }
                            if(i == 2){
                                dataArr.push({
                                    name: '预警',
                                    value: res.data.data['warn']
                                });
                            }
                            if(i == 3){
                                dataArr.push({
                                    name: '隐患',
                                    value: res.data.data['hiddenHazard']
                                });
                            }
                            if(i == 4){
                                dataArr.push({
                                    name: '故障',
                                    value: res.data.data['fault']
                                });
                            }
                        }
                        this.topMidInit(dataArr, 'mid');
                    }else{
                        this.no_data_status_mid = true;
                        return false;
                    }
                });
            },
            getBotData(){
                this.ani_status_bot = true;
                let dataObj = {
                    type: 'get',
                    url: '/mcbw/dep_stats/trent/staDate/count',
                    obj: {
                        "pageSize":100,
                        "currentPage":1,
                        "areaId":"",
                        "dataType": "",
                        "beginDate": this.beginTime,
                        "endDate": this.endTime,
                    }
                }
                this.$Axios(dataObj).then((res)=>{
                    console.log(res);
                    console.log('获取左下数据');
                    this.ani_status_bot = false;
                    if(res.data.success){
                        //处理数据
                        Object.keys(res.data.data).forEach((item,index)=>{
                            let arr = [];
                            for(let i = 0;i < this.timeArr.length; i++){
                                let _itemI = '';
                                for(let k = 0; k < res.data.data[item].length; k++){
                                    if(res.data.data[item][k].staDate == this.timeArr[i]){
                                        _itemI = k;
                                        break;
                                    }
                                }
                                if(_itemI !== ''){
                                    arr[i] = res.data.data[item][_itemI];
                                }else{
                                    arr[i] = {
                                        count: 0,
                                        staDate: this.timeArr[i],
                                    }
                                }
                            }
                            res.data.data[item] = arr;
                        });
                        this.leftBotInit(res.data.data);
                    }
                    
                }).catch((res)=>{
                    this.ani_status_bot = false;
                });
            },
            topMidInit(data, dom) {
                //左上图
                let that = this;
                let option = {
                    tooltip: {
                        trigger: "axis",
                        formatter: function (params) {
                            // console.log(params[0]);
                            let res = `<div>单位：${data[params[0].dataIndex].name}</div>`;
                            res += `<p>数量：${params[0].value}</p>`;
                            return res;
                        },
                      backgroundColor:"rgba(50, 50, 50, .7)",
                      borderColor:"rgba(50, 50, 50, 1)",
                      textStyle:{
                        color:"#FFFFFF"
                      },
                      confine: true
                    },
                    calculable: true,
                    grid: {
                        left: "3%",
                        right: "4%",
                        bottom: "3%",
                        top: "15%",
                        containLabel: true
                    },
                    xAxis: [
                        {
                            type: "category",
                            data: that.left_name_substr(data, 'name'),
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: "#122856",
                              }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: that.echarts_color,
                                    fontSize:14,
                                },
                                interval:0,
                                // rotate:40,
                                fontSize: 10
                            }
                        }
                    ],
                    yAxis: [
                        {
                            type: "value",
                            minInterval : 1,//最小间隔
                            axisLine: {
                              show: true,
                              lineStyle: {
                                color: "#06122c",
                              }
                            },
                            axisLabel: {
                                textStyle: {
                                    color: that.echarts_color
                                }
                            },
                            splitLine: {
                              lineStyle: {
                                color: "#122856",
                              }
                            }
                        }
                    ],
                    series: [
                        {
                            name: that.right_bot_click_text + '数',
                            type: "bar",
                            data: that.left_name_substr(data, 'value'),
                            barWidth: 30,
                            itemStyle: {
                                normal: {
                                    // color:{
                                    //   type: "linear",
                                    //   x: 0,
                                    //   y: 0,
                                    //   x2: 0,
                                    //   y2: 1,
                                    //   colorStops: [
                                    //     {
                                    //       offset: 0,
                                    //       color: "#fd6760" // 0% 处的颜色
                                    //     },
                                    //     {
                                    //       offset: 1,
                                    //       color: "rgba(0,0,0,0)" // 100% 处的颜色
                                    //     }
                                    //   ],
                                    //   globalCoord: false // 缺省为 false
                                    // }
                                    color: "#fd6760",
                                }
                            }
                        }
                    ]
                };
                this.topOption = option;
                if(dom == 'top'){
                    this.left_top_echart = this.$echarts.init(document.getElementById("left_top"));
                    this.left_top_echart.setOption(option);
                    this.$emit('left_top', this.left_top_echart);
                    this.left_top_echart.off('click');
                    this.left_top_echart.on('click', function (params) {
                        let obj = {
                            status: true,
                            type: 'leftTop'
                        }
                        console.log(obj);
                        that.$store.commit('showLayer', obj);
                    });
                }else if(dom == 'mid'){
                    this.left_mid_echart = this.$echarts.init(document.getElementById("left_mid"));
                    this.left_mid_echart.setOption(option);
                    this.$emit('left_mid', this.left_mid_echart);
                    this.left_mid_echart.off('click');
                    this.left_mid_echart.on('click', function (params) {
                        let obj = {
                            status: true,
                            type: 'leftMid',
                            navIndex: params.dataIndex,
                        }
                        console.log(params);
                        
                        console.log(obj);
                        that.$store.commit('showLayer', obj);
                    });
                }
            },
            left_name_substr(data,type){
                let name_arr = [];
                let value_arr = [];
                for(let i = 0;i<data.length;i++){
                    if(data[i].name.length <= 4){
                        name_arr.push(data[i].name);
                    }else{
                        name_arr.push(data[i].name.substr(0, 4) + '...');
                    }
                    value_arr.push(data[i].value);
                }
                if(type == 'name'){
                    return name_arr;
                    //这里进行一下字数限制，如果大于4个字，就省略号显示
                }else{
                    return value_arr;
                }
            }
        }
    };
</script>
<style lang="scss" scoped>
  .left_list_wrap {
    position: absolute;
    bottom: 0;
    left: 0;
    color: #fff;
    height: calc(100% - 120px);
    width: 500px;
    transition: all 1s;
    transform: translateX(0);
    z-index: 10;
  }
  .yincang_active{
    transform: translateX(-100%);
  }
  .left_top_wrap{
    .no_data_pic_wrap, .ani_wrap{
      height: calc(100% - 31px);
      top: 31px;
    }
  }
  .left_mid_wrap{
    .no_data_pic_wrap, .ani_wrap{
      height: 100%;
      top: 0;
    }
    #left_Mid{
      box-sizing: border-box;
      padding: 5px 20px;
      ul.mid_data_nav{
        font-size: 0;
        border-bottom: 1px solid rgba(204, 204, 204, .6);
        background: rgba(0,45,52,.8);
        li{
          display: inline-block;
          font-size: 14px;
          // color: #03e2f4;
          text-align: center;
        }
        li:first-child{
          width: 15%;
        }
        li:nth-child(2){
          width: 40%;
        }
        li:last-child{
          width: 45%;
        }
      }
      ul.mid_data_wrap{
        li{
            height: 30px;
            line-height: 30px;
            font-size: 0;
            border-bottom: 1px solid rgba(204, 204, 204, .6);
            &:hover{
                background: rgba(132, 239, 243, .36);
            }
          span{
            display: inline-block;
            font-size: 14px;
            // color: #03e2f4;
            text-align: center;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .sum{
            width: 15%;
          }
          .company_name{
            width: 40%;
          }
          .time{
            width: 45%;
          }
        }
      }
    }
  }
  .left_bot_wrap{
    .no_data_pic_wrap, .ani_wrap{
      height: 100%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/leftList.vue